import { type AxiosResponse } from 'axios'
import { type AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import {
  type IResponseReferralsCreate,
  type IResponseReferralsHistory,
  type IParamsSetPaypalEmail,
  type IResponseSetPaypalEmail,
} from 'entities/Referrals'

class Api {
  getReferralsHistory(options?: AxiosOptions): Promise<AxiosResponse<IResponseReferralsHistory>> {
    return baseApi.get('user-referrals/stats', { ...options })
  }

  createReferrals(): Promise<AxiosResponse<IResponseReferralsCreate>> {
    return baseApi.post('user-referrals/create')
  }

  setPaypalEmail(params?: IParamsSetPaypalEmail): Promise<AxiosResponse<IResponseSetPaypalEmail>> {
    return baseApi.patch('user-referrals/paypal-email', params)
  }
}

export const ReferralsApi = new Api()
